export const getNameComponents = (fullName) => {
  if (!fullName) {
    return {
      firstName: "",
      lastName: "",
    };
  }
  const components = fullName.split(" ");
  components.forEach((name, index) => {
    components[index] = name.charAt(0).toUpperCase() + name.substring(1).toLowerCase();
  });

  return {
    firstName: components.slice(0, components.length - 1).join(" "),
    lastName: components[components.length - 1],
  };
};
